
export interface Ticket {
  id: string;
  title: string;
  description: string;
  type: "Incidente" | "Requisição" | "Problema" | "Mudança";
  category: string;
  subcategory: string;
  priority: "Crítica" | "Alta" | "Média" | "Baixa";
  status: "Aberto" | "Em atendimento" | "Aguardando resposta" | "Resolvido" | "Fechado";
  assignee: string;
  requester: string;
  createdAt: string;
  updatedAt: string;
  slaRemaining: string;
  slaDeadline: string;
  comments: Comment[];
  attachments?: string[];
}

export interface Comment {
  id: string;
  author: string;
  content: string;
  timestamp: string;
  isInternal: boolean;
}

export const mockTickets: Ticket[] = [
  {
    id: "INC-2024-001",
    title: "Sistema de e-mail corporativo indisponível",
    description: "Não consigo acessar o sistema de e-mail corporativo. Aparece erro de conexão com o servidor.",
    type: "Incidente",
    category: "Infraestrutura",
    subcategory: "E-mail",
    priority: "Crítica",
    status: "Em atendimento",
    assignee: "João Silva - Infraestrutura",
    requester: "Maria Santos",
    createdAt: "2024-01-15 09:30",
    updatedAt: "2024-01-15 10:15",
    slaRemaining: "2h 15min",
    slaDeadline: "2024-01-15 14:00",
    comments: [
      {
        id: "1",
        author: "Maria Santos",
        content: "Sistema começou a apresentar problemas por volta das 9h da manhã.",
        timestamp: "2024-01-15 09:30",
        isInternal: false
      },
      {
        id: "2",
        author: "João Silva",
        content: "Identificamos problema no servidor de e-mail. Estamos trabalhando na correção.",
        timestamp: "2024-01-15 10:15",
        isInternal: false
      }
    ]
  },
  {
    id: "REQ-2024-002",
    title: "Solicitação de acesso ao sistema de vendas",
    description: "Preciso de acesso ao sistema de vendas para consultar relatórios mensais.",
    type: "Requisição",
    category: "Acesso e Permissões",
    subcategory: "Sistema de Vendas",
    priority: "Média",
    status: "Aguardando resposta",
    assignee: "Ana Costa - Segurança TI",
    requester: "Carlos Pereira",
    createdAt: "2024-01-14 14:20",
    updatedAt: "2024-01-14 16:30",
    slaRemaining: "1 dia 4h",
    slaDeadline: "2024-01-16 14:20",
    comments: [
      {
        id: "3",
        author: "Carlos Pereira",
        content: "Meu gestor já aprovou o acesso. Segue aprovação em anexo.",
        timestamp: "2024-01-14 14:20",
        isInternal: false
      },
      {
        id: "4",
        author: "Ana Costa",
        content: "Preciso validar com o RH. Aguarde retorno em até 24h.",
        timestamp: "2024-01-14 16:30",
        isInternal: false
      }
    ]
  },
  {
    id: "PRB-2024-001",
    title: "Lentidão recorrente no sistema ERP",
    description: "Sistema ERP apresenta lentidão constante nos últimos dias, afetando produtividade.",
    type: "Problema",
    category: "Performance",
    subcategory: "ERP",
    priority: "Alta",
    status: "Aberto",
    assignee: "Pedro Oliveira - Infraestrutura",
    requester: "Departamento Financeiro",
    createdAt: "2024-01-13 11:45",
    updatedAt: "2024-01-13 11:45",
    slaRemaining: "6h 30min",
    slaDeadline: "2024-01-14 11:45",
    comments: [
      {
        id: "5",
        author: "Departamento Financeiro",
        content: "Lentidão começou na segunda-feira. Relatórios que levavam 2 min agora levam 15 min.",
        timestamp: "2024-01-13 11:45",
        isInternal: false
      }
    ]
  },
  {
    id: "CHG-2024-001",
    title: "Atualização do sistema operacional dos servidores",
    description: "Aplicar patches de segurança nos servidores de produção conforme cronograma.",
    type: "Mudança",
    category: "Infraestrutura",
    subcategory: "Servidores",
    priority: "Média",
    status: "Resolvido",
    assignee: "Equipe Infraestrutura",
    requester: "Coordenação TI",
    createdAt: "2024-01-10 08:00",
    updatedAt: "2024-01-12 18:00",
    slaRemaining: "Concluído",
    slaDeadline: "2024-01-15 08:00",
    comments: [
      {
        id: "6",
        author: "Coordenação TI",
        content: "Mudança programada para o final de semana conforme janela de manutenção.",
        timestamp: "2024-01-10 08:00",
        isInternal: false
      },
      {
        id: "7",
        author: "Equipe Infraestrutura",
        content: "Patches aplicados com sucesso. Sistemas funcionando normalmente.",
        timestamp: "2024-01-12 18:00",
        isInternal: false
      }
    ]
  },
  {
    id: "INC-2024-005",
    title: "Impressora do 3º andar não funciona",
    description: "Impressora HP do 3º andar não responde aos comandos de impressão.",
    type: "Incidente",
    category: "Hardware",
    subcategory: "Impressoras",
    priority: "Baixa",
    status: "Fechado",
    assignee: "Ricardo Santos - Suporte",
    requester: "Secretaria Administrativa",
    createdAt: "2024-01-08 10:30",
    updatedAt: "2024-01-09 15:20",
    slaRemaining: "Concluído",
    slaDeadline: "2024-01-10 10:30",
    comments: [
      {
        id: "8",
        author: "Secretaria Administrativa",
        content: "Impressora parou de funcionar de repente. LED piscando em vermelho.",
        timestamp: "2024-01-08 10:30",
        isInternal: false
      },
      {
        id: "9",
        author: "Ricardo Santos",
        content: "Problema resolvido. Era apenas papel atolado. Impressora funcionando.",
        timestamp: "2024-01-09 15:20",
        isInternal: false
      }
    ]
  }
];

export const categories = [
  {
    name: "Infraestrutura",
    subcategories: ["Rede", "Servidores", "E-mail", "Internet", "Telefonia"]
  },
  {
    name: "Hardware",
    subcategories: ["Computadores", "Impressoras", "Monitores", "Periféricos"]
  },
  {
    name: "Software",
    subcategories: ["Sistemas Corporativos", "Office", "Antivírus", "Navegadores"]
  },
  {
    name: "Acesso e Permissões",
    subcategories: ["Sistema de Vendas", "ERP", "CRM", "Recursos Humanos"]
  },
  {
    name: "Performance",
    subcategories: ["Lentidão", "Travamentos", "Erro de Sistema", "ERP"]
  }
];

// Matriz de SLA baseada nas regras da página /sla
// Valores são de RESOLUÇÃO (tempo total para resolver)
export const slaMatrix = {
  "Crítica": { 
    incident: "4h",   // Resolução: 4h (Resposta: 1h)
    request: "8h",    // Resolução: 8h (Resposta: 2h)
    problem: "8h",    // Resolução: 8h (Resposta: 2h)
    change: "24h"     // Resolução: 24h (Resposta: 4h)
  },
  "Alta": { 
    incident: "8h",   // Resolução: 8h (Resposta: 2h)
    request: "24h",   // Resolução: 24h (Resposta: 4h)
    problem: "24h",   // Resolução: 24h (Resposta: 4h)
    change: "48h"     // Resolução: 48h (Resposta: 8h)
  },
  "Média": { 
    incident: "24h",  // Resolução: 24h (Resposta: 4h)
    request: "48h",   // Resolução: 48h (Resposta: 8h)
    problem: "48h",   // Resolução: 48h (Resposta: 8h)
    change: "48h"     // Resolução: 48h (Resposta: 24h)
  },
  "Baixa": { 
    incident: "48h",  // Resolução: 48h (Resposta: 8h)
    request: "48h",   // Resolução: 48h (Resposta: 24h)
    problem: "48h",   // Resolução: 48h (Resposta: 24h)
    change: "120h"    // Resolução: 120h (Resposta: 48h)
  }
};

// Matriz de tempo de primeira resposta
export const responseTimeMatrix = {
  "Crítica": { 
    incident: "1h",
    request: "2h",
    problem: "2h",
    change: "4h"
  },
  "Alta": { 
    incident: "2h",
    request: "4h",
    problem: "4h",
    change: "8h"
  },
  "Média": { 
    incident: "4h",
    request: "8h",
    problem: "8h",
    change: "24h"
  },
  "Baixa": { 
    incident: "8h",
    request: "24h",
    problem: "24h",
    change: "48h"
  }
};
